import SiteDto from "../Common/dtos/SiteDto";
import { QueryOptions } from "../Common/useQuery";
import useUserOrEmployeeQuery from "../Common/useUserOrEmployeeQuery";
import { useKaEmployee } from "../UserAccess/useKaEmployee";

const useGetSites = (options?: QueryOptions<SiteDto[]>) => {
  const { selectedBusiness } = useKaEmployee();

  return useUserOrEmployeeQuery<SiteDto[]>(
    { path: `/api/sites/businesses/${selectedBusiness?.id!}` },
    options);
}

export default useGetSites;
